import type { DuplicateNotification } from '@ikegps/core-api';

/**
 * Bucket `DuplicateNotification` items into errors vs warnings.
 *
 * - `duplicate_failed` is an error (the pole did not get duplicated).
 * - `span_demoted_*` are warnings (the pole was duplicated but a span got changed).
 */
export class DuplicateNotificationCtrl {
	notifications: DuplicateNotification[];
	errors: DuplicateNotification[];
	warnings: DuplicateNotification[];
	hadFailure: boolean;

	constructor(notifications: DuplicateNotification[], opts: { hadFailure: boolean }) {
		this.notifications = notifications;
		this.errors = notifications.filter((n) => n.code === 'duplicate_failed');
		this.warnings = notifications.filter((n) => n.code !== 'duplicate_failed');
		this.hadFailure = opts.hadFailure || this.errors.length > 0;
	}

	get hasOnlyWarnings(): boolean {
		return !this.hadFailure && this.warnings.length > 0;
	}
}
